import axios from "axios";

// systemAdmin-only: drive the article cover → S3 backfill.
// `pageIds` limits the run to those articles; without it every page is walked.
const start = (pageIds) =>
  axios.post(
    "api/v1/admin/pages/cover-backfill/start",
    pageIds?.length ? { pageIds } : {}
  );
const stop = () => axios.post("api/v1/admin/pages/cover-backfill/stop");
const getStatus = () => axios.get("api/v1/admin/pages/cover-backfill/status");

const ApiArticleCoverBackfill = { start, stop, getStatus };

export default ApiArticleCoverBackfill;
